"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
console.log('Homepage JS loaded');
// Import styles
require("../scss/page-home.scss");
// Import JS
